<template>
  <div>
    <ContentHeader title="Add Bank Account" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="card card-primary">
              <form @submit.prevent="handleCreateData()">
                <div class="card-body">
                  <div class="form-group">
                    <label for="bank-name">Bank Name</label>
                    <select
                      placeholder="Enter Bank Name"
                      id="bank-name"
                      v-model="payload.bank_name"
                      class="form-select"
                      :class="{
                        'border-danger': $v.payload.bank_name.$error,
                      }"
                    >
                      <option
                        v-for="item in bank_list"
                        :key="item.index"
                        :value="item.name"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div class="text-danger" v-if="$v.payload.bank_name.$error">
                      <small>Bank Name Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="owner-name">Owner Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="owner-name"
                      placeholder="Enter Owner Name"
                      :class="{
                        'border-danger': $v.payload.owner_name.$error,
                      }"
                      v-model="payload.owner_name"
                    />
                    <div
                      class="text-danger"
                      v-if="$v.payload.owner_name.$error"
                    >
                      <small>Owner Name Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="account-number">Account Number</label>
                    <input
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      class="form-control"
                      id="account-number"
                      placeholder="Enter Account Number"
                      :class="{
                        'border-danger':
                          $v.payload.account_number.$error ||
                          !$v.payload.account_number.numeric,
                      }"
                      v-model="payload.account_number"
                    />
                    <div
                      class="text-danger"
                      v-if="$v.payload.account_number.$error"
                    >
                      <small>Account Number Required</small>
                    </div>
                    <div
                      class="text-danger"
                      v-if="!$v.payload.account_number.numeric"
                    >
                      <small>This field only accept Number</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="branch-name">Branch Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="branch-name"
                      placeholder="Enter Branch Name"
                      :class="{
                        'border-danger': $v.payload.branch_name.$error,
                      }"
                      v-model="payload.branch_name"
                    />
                    <div
                      class="text-danger"
                      v-if="$v.payload.branch_name.$error"
                    >
                      <small>Bank Name Required</small>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <router-link
                    class="btn btn-outline-danger mr-3"
                    :to="{ name: 'Bank' }"
                  >
                    Back
                  </router-link>
                  <button
                    type="submit"
                    href="#"
                    class="btn btn-success"
                    :disabled="submitStatus === 'PENDING'"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiVendor from "../../services/VendorApiServices";
import { required, numeric } from "vuelidate/lib/validators";
import axios from "axios";

export default {
  data() {
    return {
      bank_list: [],
      payload: {
        bank_name: "BANK MANDIRI",
        owner_name: "",
        account_number: "",
        branch_name: "",
      },
      submitStatus: null,
    };
  },

  components: {
    ContentHeader,
  },
  validations: {
    payload: {
      bank_name: {
        required,
      },
      owner_name: {
        required,
      },
      account_number: {
        required,
        numeric,
      },
      branch_name: {
        required,
      },
    },
  },
  async mounted() {
    try {
      let bankList = await axios.get(process.env.VUE_APP_BANK_BASE_URL);
      this.bank_list = bankList.data.data;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    handleCreateData() {
      let data = new FormData();

      data.append("vendor_robot_id", this.$store.getters.user.id);
      data.append("bank_name", this.payload.bank_name);
      data.append("owner_name", this.payload.owner_name);
      data.append("account_number", this.payload.account_number);
      data.append("branch_name", this.payload.branch_name);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        this.$swal({
          title: "Are you sure?",
          html: "<p class='text-center'>Make sure your bank Account is Active. You can only change this by contacting our Customer Services</p>",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Add it!",
        }).then(async (result) => {
          this.submitStatus = "OK";
          if (result.isConfirmed) {
            try {
              await apiVendor.post("bank/", data);

              this.$swal(
                "Added!",
                "Bank account has been added.",
                "success"
              ).then(() => {
                this.$router.push({ name: "Bank" });
              });
            } catch (error) {
              this.submitStatus = "ERROR";
              let errorMsg = null;

              if (error.data.data.account_number) {
                errorMsg = error.data.data.account_number[0];
              } 
              
              if (error.data.data.vendor_robot_id) {
                errorMsg = error.data.data.vendor_robot_id[0];
              }

              this.$swal("Fail!", errorMsg, "error");
            }
          }
        });
      }
    },
  },
};
</script>
